/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAxovaNasSyncEventDtoEvent } from '../models/work-axova-nas-sync-event-dto-event';
import { WorkAxovaNasSyncFolderCreatedDto } from '../models/work-axova-nas-sync-folder-created-dto';
import { WorkAxovaNasSyncHeartbeatDto } from '../models/work-axova-nas-sync-heartbeat-dto';
import { WorkAxovaNasSyncPendingFolderDto } from '../models/work-axova-nas-sync-pending-folder-dto';
import { WorkAxovaNasSyncStatusDto } from '../models/work-axova-nas-sync-status-dto';

@Injectable({ providedIn: 'root' })
export class WorkAxovaNasSyncV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `axovaNasSyncV2ControllerFindPendingFolders()` */
  static readonly AxovaNasSyncV2ControllerFindPendingFoldersPath = '/v2/axova/nas-sync/folders/pending';

  /**
   * Kontakte, für die auf dem NAS noch ein Kundenordner fehlt.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `axovaNasSyncV2ControllerFindPendingFolders()` instead.
   *
   * This method doesn't expect any request body.
   */
  axovaNasSyncV2ControllerFindPendingFolders$Response(
    params: {

    /**
     * Tenant API Key mit Permission-Modul "nassync"
     */
      'X-API-Key': string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkAxovaNasSyncPendingFolderDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAxovaNasSyncV2Service.AxovaNasSyncV2ControllerFindPendingFoldersPath, 'get');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkAxovaNasSyncPendingFolderDto>>;
      })
    );
  }

  /**
   * Kontakte, für die auf dem NAS noch ein Kundenordner fehlt.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `axovaNasSyncV2ControllerFindPendingFolders$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  axovaNasSyncV2ControllerFindPendingFolders(
    params: {

    /**
     * Tenant API Key mit Permission-Modul "nassync"
     */
      'X-API-Key': string;
    },
    context?: HttpContext
  ): Observable<Array<WorkAxovaNasSyncPendingFolderDto>> {
    return this.axovaNasSyncV2ControllerFindPendingFolders$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkAxovaNasSyncPendingFolderDto>>): Array<WorkAxovaNasSyncPendingFolderDto> => r.body)
    );
  }

  /** Path part for operation `axovaNasSyncV2ControllerMarkFolderCreated()` */
  static readonly AxovaNasSyncV2ControllerMarkFolderCreatedPath = '/v2/axova/nas-sync/folders/{contactId}/created';

  /**
   * Bestätigt, dass der Kundenordner auf dem NAS angelegt wurde (setzt contacts.folder_created).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `axovaNasSyncV2ControllerMarkFolderCreated()` instead.
   *
   * This method doesn't expect any request body.
   */
  axovaNasSyncV2ControllerMarkFolderCreated$Response(
    params: {

    /**
     * Tenant API Key mit Permission-Modul "nassync"
     */
      'X-API-Key': string;
      contactId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAxovaNasSyncFolderCreatedDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAxovaNasSyncV2Service.AxovaNasSyncV2ControllerMarkFolderCreatedPath, 'post');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
      rb.path('contactId', params.contactId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAxovaNasSyncFolderCreatedDto>;
      })
    );
  }

  /**
   * Bestätigt, dass der Kundenordner auf dem NAS angelegt wurde (setzt contacts.folder_created).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `axovaNasSyncV2ControllerMarkFolderCreated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  axovaNasSyncV2ControllerMarkFolderCreated(
    params: {

    /**
     * Tenant API Key mit Permission-Modul "nassync"
     */
      'X-API-Key': string;
      contactId: number;
    },
    context?: HttpContext
  ): Observable<WorkAxovaNasSyncFolderCreatedDto> {
    return this.axovaNasSyncV2ControllerMarkFolderCreated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAxovaNasSyncFolderCreatedDto>): WorkAxovaNasSyncFolderCreatedDto => r.body)
    );
  }

  /** Path part for operation `axovaNasSyncV2ControllerHeartbeat()` */
  static readonly AxovaNasSyncV2ControllerHeartbeatPath = '/v2/axova/nas-sync/heartbeat';

  /**
   * Lebenszeichen des Agenten (wird mit TTL in Redis gehalten, siehe GET status für Admins).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `axovaNasSyncV2ControllerHeartbeat()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  axovaNasSyncV2ControllerHeartbeat$Response(
    params: {

    /**
     * Tenant API Key mit Permission-Modul "nassync"
     */
      'X-API-Key': string;
      body: WorkAxovaNasSyncHeartbeatDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAxovaNasSyncStatusDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAxovaNasSyncV2Service.AxovaNasSyncV2ControllerHeartbeatPath, 'post');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAxovaNasSyncStatusDto>;
      })
    );
  }

  /**
   * Lebenszeichen des Agenten (wird mit TTL in Redis gehalten, siehe GET status für Admins).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `axovaNasSyncV2ControllerHeartbeat$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  axovaNasSyncV2ControllerHeartbeat(
    params: {

    /**
     * Tenant API Key mit Permission-Modul "nassync"
     */
      'X-API-Key': string;
      body: WorkAxovaNasSyncHeartbeatDto
    },
    context?: HttpContext
  ): Observable<WorkAxovaNasSyncStatusDto> {
    return this.axovaNasSyncV2ControllerHeartbeat$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAxovaNasSyncStatusDto>): WorkAxovaNasSyncStatusDto => r.body)
    );
  }

  /** Path part for operation `axovaNasSyncV2ControllerListenToEvents()` */
  static readonly AxovaNasSyncV2ControllerListenToEventsPath = '/v2/axova/nas-sync/events';

  /**
   * Server-Sent Events: FOLDER_PENDING, PING (alle 30 s).
   *
   * Ereignisse sind reine Wecker ohne Zustellgarantie; der Agent gleicht danach vollständig ab.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `axovaNasSyncV2ControllerListenToEvents()` instead.
   *
   * This method doesn't expect any request body.
   */
  axovaNasSyncV2ControllerListenToEvents$Response(
    params: {

    /**
     * Tenant API Key mit Permission-Modul "nassync"
     */
      'X-API-Key': string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAxovaNasSyncEventDtoEvent>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAxovaNasSyncV2Service.AxovaNasSyncV2ControllerListenToEventsPath, 'get');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/event-stream', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAxovaNasSyncEventDtoEvent>;
      })
    );
  }

  /**
   * Server-Sent Events: FOLDER_PENDING, PING (alle 30 s).
   *
   * Ereignisse sind reine Wecker ohne Zustellgarantie; der Agent gleicht danach vollständig ab.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `axovaNasSyncV2ControllerListenToEvents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  axovaNasSyncV2ControllerListenToEvents(
    params: {

    /**
     * Tenant API Key mit Permission-Modul "nassync"
     */
      'X-API-Key': string;
    },
    context?: HttpContext
  ): Observable<WorkAxovaNasSyncEventDtoEvent> {
    return this.axovaNasSyncV2ControllerListenToEvents$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAxovaNasSyncEventDtoEvent>): WorkAxovaNasSyncEventDtoEvent => r.body)
    );
  }

  /** Path part for operation `axovaNasSyncAdminV2ControllerGetStatus()` */
  static readonly AxovaNasSyncAdminV2ControllerGetStatusPath = '/v2/axova/nas-sync/status';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `axovaNasSyncAdminV2ControllerGetStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  axovaNasSyncAdminV2ControllerGetStatus$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAxovaNasSyncStatusDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAxovaNasSyncV2Service.AxovaNasSyncAdminV2ControllerGetStatusPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAxovaNasSyncStatusDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `axovaNasSyncAdminV2ControllerGetStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  axovaNasSyncAdminV2ControllerGetStatus(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkAxovaNasSyncStatusDto> {
    return this.axovaNasSyncAdminV2ControllerGetStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAxovaNasSyncStatusDto>): WorkAxovaNasSyncStatusDto => r.body)
    );
  }

}
